import { ttsVoiceSearchFilter } from '@/state/presenters';
import theme from '@/theme';
import styled from '@emotion/styled';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { useRecoilState } from 'recoil';

const StyledTextField = styled(TextField)`
    margin: 8px 0 16px;
    background-color: #f2f2f2;
    border-radius: 8px;
    width: 100%;

    & .MuiOutlinedInput-root {
        & fieldset {
            border: none !important;
        }
    }

    input {
        font-size: 14px;
        caret-color: ${theme.colors.primary[900]};
    }
`;

const StyledInputAdornment = styled(InputAdornment)`
    color: rgba(0, 0, 0, 0.3);
`;

export const SearchField = () => {
    const [ttsVoiceSearchFilterValue, setTtsVoiceSearchFilter] = useRecoilState(ttsVoiceSearchFilter);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setTtsVoiceSearchFilter(e.target.value);
    };

    const handleClearSearch = () => {
        setTtsVoiceSearchFilter('');
    };

    return (
        <StyledTextField
            placeholder="Search voice"
            onChange={handleSearchChange}
            value={ttsVoiceSearchFilterValue}
            size="small"
            inputProps={{
                'data-testid': 'voice-search-field',
            }}
            InputProps={{
                startAdornment: (
                    <StyledInputAdornment position="start">
                        <SearchIcon />
                    </StyledInputAdornment>
                ),
                endAdornment: ttsVoiceSearchFilterValue ? (
                    <StyledInputAdornment position="end">
                        <ClearIcon cursor="pointer" onClick={handleClearSearch} />
                    </StyledInputAdornment>
                ) : null,
            }}
        />
    );
};
